// extracted by mini-css-extract-plugin
export default {"searchResultsWrapper":"Results_searchResultsWrapper__W1Xdn"};